import * as React from "react";

import { Header } from "semantic-ui-react";
import { useDispatch } from "react-redux";

import { ThunkDispatch } from "redux-thunk";

import { QuestionnaireSectionInjectedProps, QuestionnaireSectionOwnProps } from "../QuestionnaireSectionProps";
import { renderQuestions, isSectionVisible, registerQuestionsForSection } from "../utils";
import { AnsweredQuestion, QuestionMap } from "../model";
import { removeQuestion, updateQuestion, validateQuestion } from "../actions";

import { useQuestionnaireContainerForSection, useSectionWithQuestionnaireContainer } from "./QuestionnaireContainerContext";

import "../styles/progress-bar-questionnaire-section.scss";
import { QuestionnaireSectionProvider } from "./QuestionnaireSectionContext";

export const ContextAwareProgressBarQuestionnaireSection = (props: Omit<QuestionnaireSectionOwnProps, keyof QuestionnaireSectionInjectedProps>) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    useSectionWithQuestionnaireContainer(props);
    const { section, ...questionnaireContext } = useQuestionnaireContainerForSection(props.id);
    const questions: QuestionMap = React.useMemo(() => section.questions || {}, [section]);
    React.useEffect(() => {
        // hopefully we can remove this horrible registration code soon and only use React contexts
        registerQuestionsForSection({
            questions,
            id: props.id,
            children: props.children,
            questionnaireKey: questionnaireContext.questionnaireKey,
            removeQuestion: (payload: { sectionId: string; id: string; questionnaireKey: string }) => dispatch(removeQuestion(payload)),
            updateAnswer: (payload: { sectionId: string; id: string; question: AnsweredQuestion }) => dispatch(updateQuestion({ ...payload, questionnaireKey: questionnaireContext.questionnaireKey })), // eslint-disable-line max-len
        });
    }, [dispatch, props.children, props.id, questionnaireContext.questionnaireKey, questions]);
    const active = props.active || section.active;
    if (!questionnaireContext.readonly && !active) {
        return null;
    }

    if (isSectionVisible({
        questions,
        neverHide: props.neverHide,
    }) !== true) {
        return null;
    }

    return (
        <QuestionnaireSectionProvider id={props.id}>
            <Header className="section-header" as="h2" inverted block>{props.title}</Header>
            {renderQuestions({
                id: props.id,
                children: props.children,
                questions,
                questionnaireKey: questionnaireContext.questionnaireKey,
                isComplete: section.isComplete,
                updateAnswer: (payload: { sectionId: string; id: string; question: AnsweredQuestion }) => dispatch(updateQuestion({ ...payload, questionnaireKey: questionnaireContext.questionnaireKey })), // eslint-disable-line max-len
                validateQuestion: (payload: { sectionId: string; id: string; validatedQuestion: Promise<AnsweredQuestion>; questionnaireKey: string }) => dispatch(validateQuestion(payload)) // eslint-disable-line max-len
            })}
        </QuestionnaireSectionProvider>
    );
};

